import React, { useMemo } from "react";
import { AgChartOptions } from "ag-charts-community";
import { AgCharts } from "ag-charts-react";

import { seriesCurrencyTooltip } from "../util";

interface IProps {
  data: any[];
}

const OverallPositionChart: React.FC<IProps> = ({ data }) => {
  const options: AgChartOptions = useMemo(
    () => ({
      data,
      series: [
        {
          type: "line",
          xKey: "Phase",
          yKey: "CumulativeNetPosition",
          yName: "Cumulative Net Position",
          tooltip: seriesCurrencyTooltip(["CumulativeNetPosition"]),
        },
      ],
      padding: { top: 36, bottom: 36, left: 42, right: 42 },
      axes: {
        x: {
          type: "category",
          position: "bottom",
          label: {
            fontSize: 10,
          },
        },
        y: {
          type: "number",
          position: "left",
          title: {
            text: "Cumulative net position",
            fontSize: 12,
          },
          label: {
            formatter: (params) => {
              const formatted = params.value.toLocaleString("en-US", {
                notation: "compact",
                compactDisplay: "short",
              });
              return formatted.replace("G", "B");
            },
          },
        },
      },
    }),
    [data]
  );

  return <AgCharts options={options} style={{ height: "100%" }} />;
};

export default OverallPositionChart;
